import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { LogLevel } from '@/types/Logger';
import { showErrorToast } from '@/utils/toast.utils';

/**
 * Sets the live logger `LOG_LEVEL` and persists it to the matching localStorage key so
 * it survives a reload. A persist failure still leaves the in-memory change in place
 * (the toast reports it). The level is validated at the call boundary (the level select
 * in `LogsTab`), so the thunk receives an already-valid `LogLevel`.
 */
export const setLogLevelThunk = createAppAsyncThunk<LogLevel, LogLevel>(
  'debug/setLogLevel',
  (level, { extra: { loggerService } }) => {
    loggerService.configure({ level });

    try {
      globalThis.localStorage.setItem('LOG_LEVEL', level);
    } catch {
      showErrorToast('Could not persist log level (storage unavailable)');
    }

    return level;
  }
);
